import React from "react"
import List from '@mui/material/List'
import CustomListItem from "./CustomListItem"
import { Divider } from "@mui/material"
import OpaqueTransparencySection from "../misc/OpaqueTransparencySection"
import {useMediaQuery} from 'react-responsive'

export default function CustomList(props) {
    const {listData} = props

    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })

    return (<>
        <List 
            sx={{width: isTabletOrMobile? "auto" : 800}}
        >
            {
                listData.map((value, index) => {
                    return (<React.Fragment key={index}>
                        <div key={index}>
                            <OpaqueTransparencySection>
                                <CustomListItem
                                    text={value.text}
                                />
                            </OpaqueTransparencySection>
                            {listData.length - 1 !== index ?
                                <Divider variant="middle"/>
                            :
                                null
                            }
                        </div>
                        </React.Fragment>
                    )
                })
            }
        </List>
    </>)
}